import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

export const competitionConfigsService = {
  async saveVersion(competitionId, content) {
    // Get next revision using RPC function
    const { data: nextRevision, error: revisionError } = await supabase
      .rpc('get_next_revision', { comp_id: competitionId });

    if (revisionError) throw revisionError;
    const { data, error } = await supabase
      .from('competition_configs')
      .insert({
        competition_id: competitionId,
        content,
        revision: nextRevision
      })
      .select('revision, competition_id')
      .single();

    if (error) throw error;
    return data;
  },

  async getVersions(competitionId) {
    const { data, error } = await supabase
      .from('competition_configs')
      .select('revision, created_at')
      .match({ competition_id: competitionId })
      .order('revision', { ascending: false });

    if (error) {
      console.error('Supabase error:', error);
      throw new Error(`Failed to load versions: ${error.message}`);
    }
    return data;
  },

  async getVersion(competitionId, revision) {
    const { data, error } = await supabase
      .from('competition_configs')
      .select('content, revision')
      .match({ 
        competition_id: competitionId,
        revision: revision 
      })
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getLatestVersion(competitionId) {
    const { data, error } = await supabase
      .from('competition_configs')
      .select('content, revision')
      .match({ competition_id: competitionId })
      .order('revision', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async deleteVersion(competitionId, revision) {
    // Get latest version to prevent deleting it
    const latest = await this.getLatestVersion(competitionId);
    if (latest && latest.revision === revision) {
      throw new Error('Cannot delete the latest version');
    }

    // Delete the version
    const { error } = await supabase
      .from('competition_configs')
      .delete()
      .match({ 
        competition_id: competitionId,
        revision: revision 
      });

    if (error) throw error;
  }
};
